import React from "react";
import Layout from "../components/UI/Layout/Layout"
export default() =>  {
  return (
    <Layout>
      <h1>Here goes publications</h1>
    </Layout>
      );
}
